/**
 * ImageZoom - product image zoom/lightbox behaviour.
 * Custom element: <image-zoom>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import { biggerPicture } from "./vendor.js";
class ImageZoom extends ThemeComponent {
  init() {
    this.setupLightbox();
  }
  setupLightbox() {
    let lightbox = biggerPicture({
        target: document.body
      }),
      galleryLinks = this.querySelectorAll("#bigger-images-gallery a");
    for (let galleryLink of galleryLinks) galleryLink.addEventListener("click", openGallery);
    function openGallery(clickEvent) {
      clickEvent.preventDefault(), lightbox.open({
        items: galleryLinks,
        el: clickEvent.currentTarget,
        intro: "fadeup"
      });
    }
    setFunctionName(openGallery, "openGallery");
  }
}
setFunctionName(ImageZoom, "ImageZoom");
const propertyTypes = {};
ImageZoom.prototype.$name = "ImageZoom";
ImageZoom.prototype.$info = JSON.parse('{"name":"ImageZoom","meta":{"isLegacy":false,"selector":"image-zoom"},"props":[],"refs":[]}');
ImageZoom.prototype.$info.component = ImageZoom;
for (const prop of ImageZoom.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("ImageZoom/ImageZoom.ts", {
  ImageZoom: ImageZoom
}, void 0);